import React from "react";
import PropTypes from "prop-types";
import DownArrowImage from "images/down_caret_arrow.svg";
import UpArrowImage from "images/up_caret_arrow.svg";

const UpDownCaretArrow = ({ isCollapse }) => {
  return (
    <span style={{ marginLeft: "13px" }}>
      {isCollapse ? (
        <img src={UpArrowImage} alt="UpArrowImage" />
      ) : (
        <img src={DownArrowImage} alt="UpArrowImage" />
      )}
    </span>
  );
};

UpDownCaretArrow.propTypes = {
  isCollapse: PropTypes.bool.isRequired
};

export default UpDownCaretArrow;
